/**
 * Which per-seat plan the organisation tab starts on, and how its chips are
 * told apart — pure, because both were got wrong silently: the dev catalogue
 * carries a legacy flat `b2b` plan ahead of the tiered one, so position order
 * defaulted the widget to a price the confirm step then disagreed with, and
 * two plans sharing a period rendered two chips reading « Monthly ».
 */
export interface OrgPlanLike {
  key: string
  name: string
  period: string
  highlighted: boolean
}

/** The catalogue's featured plan wins; position order is only the fallback. */
export function defaultOrgPlan<T extends OrgPlanLike>(perSeat: readonly T[]): T | undefined {
  return perSeat.find((plan) => plan.highlighted) ?? perSeat[0]
}

/**
 * A chip label is the period word until the period stops distinguishing the
 * plans — then it is the plan's own per-locale name, which is the one string
 * the catalogue guarantees differs.
 */
export function chipUsesPlanName(perSeat: readonly OrgPlanLike[], candidate: OrgPlanLike): boolean {
  return perSeat.filter((plan) => plan.period === candidate.period).length > 1
}
